import React from 'react'
import ReactDOM from 'react-dom/client'
import '../../translation/i18n'
import { SearchBar } from '../../components/search-bar/SearchBar'
import { PlanContents } from '../../components/plan-contents/PlanContents'
import { CategoryFilter } from '../../components/category-filter'
import { PlanItem } from '../../components/plan-item/PlanItem'
import { SearchCalendar } from '../../components/landing-page/availability-tab/SearchCalendar'
import { LpAvailability } from '../../components/landing-page/availability-tab/LpAvailability'

// Render React components by id
const reactElements = {
  'search-bar-mobile': SearchBar,
  'search-bar-pc': SearchBar,
  'category-filter': CategoryFilter,
  'plan-item': PlanItem,
  'search-calendar': SearchCalendar,
  'lp-availability': LpAvailability,
}

Object.entries(reactElements).forEach(([id, Component]) => {
  const element = document.getElementById(id) as HTMLElement
  if (element) {
    ReactDOM.createRoot(element).render(
      <React.StrictMode>
        <Component />
      </React.StrictMode>,
    )
  }
})

// Render React components by class
const planContents = document.getElementsByClassName('plan-contents') as HTMLCollectionOf<HTMLElement>
Array.from(planContents).forEach((element, index) => {
  const dataPlans = element.getAttribute('data-plans')
  const isShowOptions = !window.location.pathname.includes('plans') && index === 0

  ReactDOM.createRoot(element).render(
    <React.StrictMode>
      <PlanContents dataContent={JSON.parse(dataPlans)} isShowOptions={isShowOptions} />
    </React.StrictMode>,
  )
})
